import React from 'react';
import { StepProgress } from '@wix/gg-components';
import { useStepperPosition } from 'hooks/flow/useStepperPosition';

export function StepHeader() {
  const { currentStep, totalSteps } = useStepperPosition();

  return <StepProgress currentStep={currentStep} totalSteps={totalSteps} />;
}
